<div>
  <div class="dialog-body">
    @if (checkResult.canDelete) {
      <div class="dialog-content-description gea-font-body-20">
        Are you sure you want to delete workspace <strong>{{ workspace }}</strong
        >?
      </div>
      <div class="dialog-warning">
        <div class="dialog-callout-header">
          <i class="pi pi-exclamation-triangle dialog-warning-icon"></i>
          <span class="dialog-warning-label">Warning</span>
        </div>
        <p class="dialog-warning-text">All changes made inside this workspace will be lost. This action cannot be undone.</p>
      </div>
    } @else {
      <div class="dialog-content-description gea-font-body-20">
        Cannot delete workspace <strong>{{ workspace }}</strong>
      </div>
      <div class="dialog-note">
        <div class="dialog-callout-header">
          <i class="pi pi-info-circle dialog-note-icon"></i>
          <span class="dialog-note-label">Note</span>
        </div>
        <p class="dialog-note-text">{{ blockedMessage }}</p>
      </div>
    }
  </div>
  <p-divider />
  <div class="p-dialog-footer">
    @if (checkResult.canDelete) {
      <geaui-button-v3 [disabled]="isDeleting()" (click)="cancel()" type="secondary">Cancel</geaui-button-v3>
      <geaui-button-v3 [sending]="isDeleting()" [disabled]="isDeleting()" (click)="confirm()" information="error"
        >Delete</geaui-button-v3
      >
    } @else {
      <geaui-button-v3 (click)="cancel()" type="secondary">OK</geaui-button-v3>
    }
  </div>
</div>
